module.exports = __webpack_public_path__ + "img/parkour_6.bf831d21.jpg";